@if (document(); as document) {
  <div class="information">
    <p class="f-body-m f-medium">
      {{
        `${DictionaryCode.CONTRACTOR_DOCUMENT_TYPE}.${document.type}`
          | translate
      }}
    </p>

    <p class="f-body-xs f-muted">
      @if (document.expirationDate?.indefinite) {
        {{ 'labels.indefiniteTime' | translate | lowercase }}
      } @else {
        {{ 'labels.to' | translate | lowercase }}
        {{ document.expirationDate?.date! | onyxDate: 'date' }}
      }
    </p>
  </div>
} @else {
  -
}
